export default {
  pt: {
    'shipments.adicionarCargasDialog.error.quantity': 'Informe uma quantidade maior que zero.',
    'shipments.adicionarCargasDialog.error.maxLoads': 'Máximo de {{max}} cargas por vez.',
    'shipments.adicionarCargasDialog.error.startDate': 'Informe a data inicial.',
    'shipments.adicionarCargasDialog.error.startTime': 'Informe o horário inicial.',
    'shipments.adicionarCargasDialog.error.interval': 'Informe um intervalo maior que zero.',
    'shipments.adicionarCargasDialog.addedOne': '{{count}} carga adicionada.',
    'shipments.adicionarCargasDialog.addedMany': '{{count}} cargas adicionadas.',
    'shipments.adicionarCargasDialog.title': 'Adicionar cargas',
    'shipments.adicionarCargasDialog.description': 'Cadenciamento: as viagens são geradas em sequência a partir da data/horário inicial.',
    'shipments.adicionarCargasDialog.quantity': 'Quantidade',
    'shipments.adicionarCargasDialog.startDate': 'Data inicial',
    'shipments.adicionarCargasDialog.startTime': 'Horário inicial',
    'shipments.adicionarCargasDialog.interval': 'Intervalo',
    'shipments.adicionarCargasDialog.unit': 'Unidade',
    'shipments.adicionarCargasDialog.searchUnit': 'Buscar unidade…',
    'shipments.adicionarCargasDialog.minutes': 'minutos',
    'shipments.adicionarCargasDialog.hours': 'horas',
    'shipments.adicionarCargasDialog.preview': 'Prévia',
    'shipments.adicionarCargasDialog.previewOne': '{{count}} linha',
    'shipments.adicionarCargasDialog.previewMany': '{{count}} linhas',
    'shipments.adicionarCargasDialog.adding': 'Adicionando…',
    'shipments.adicionarCargasDialog.addOneLine': 'Adicionar linha',
    'shipments.adicionarCargasDialog.addLines': 'Adicionar linhas',
  },
  en: {
    'shipments.adicionarCargasDialog.error.quantity': 'Enter a quantity greater than zero.',
    'shipments.adicionarCargasDialog.error.maxLoads': 'Maximum of {{max}} loads at a time.',
    'shipments.adicionarCargasDialog.error.startDate': 'Enter the start date.',
    'shipments.adicionarCargasDialog.error.startTime': 'Enter the start time.',
    'shipments.adicionarCargasDialog.error.interval': 'Enter an interval greater than zero.',
    'shipments.adicionarCargasDialog.addedOne': '{{count}} load added.',
    'shipments.adicionarCargasDialog.addedMany': '{{count}} loads added.',
    'shipments.adicionarCargasDialog.title': 'Add loads',
    'shipments.adicionarCargasDialog.description': 'Scheduling: trips are generated sequentially from the start date/time.',
    'shipments.adicionarCargasDialog.quantity': 'Quantity',
    'shipments.adicionarCargasDialog.startDate': 'Start date',
    'shipments.adicionarCargasDialog.startTime': 'Start time',
    'shipments.adicionarCargasDialog.interval': 'Interval',
    'shipments.adicionarCargasDialog.unit': 'Unit',
    'shipments.adicionarCargasDialog.searchUnit': 'Search unit…',
    'shipments.adicionarCargasDialog.minutes': 'minutes',
    'shipments.adicionarCargasDialog.hours': 'hours',
    'shipments.adicionarCargasDialog.preview': 'Preview',
    'shipments.adicionarCargasDialog.previewOne': '{{count}} row',
    'shipments.adicionarCargasDialog.previewMany': '{{count}} rows',
    'shipments.adicionarCargasDialog.adding': 'Adding…',
    'shipments.adicionarCargasDialog.addOneLine': 'Add row',
    'shipments.adicionarCargasDialog.addLines': 'Add rows',
  },
  es: {
    'shipments.adicionarCargasDialog.error.quantity': 'Introduzca una cantidad mayor que cero.',
    'shipments.adicionarCargasDialog.error.maxLoads': 'Máximo de {{max}} cargas por vez.',
    'shipments.adicionarCargasDialog.error.startDate': 'Introduzca la fecha inicial.',
    'shipments.adicionarCargasDialog.error.startTime': 'Introduzca la hora inicial.',
    'shipments.adicionarCargasDialog.error.interval': 'Introduzca un intervalo mayor que cero.',
    'shipments.adicionarCargasDialog.addedOne': '{{count}} carga añadida.',
    'shipments.adicionarCargasDialog.addedMany': '{{count}} cargas añadidas.',
    'shipments.adicionarCargasDialog.title': 'Añadir cargas',
    'shipments.adicionarCargasDialog.description': 'Programación: los viajes se generan en secuencia a partir de la fecha/hora inicial.',
    'shipments.adicionarCargasDialog.quantity': 'Cantidad',
    'shipments.adicionarCargasDialog.startDate': 'Fecha inicial',
    'shipments.adicionarCargasDialog.startTime': 'Hora inicial',
    'shipments.adicionarCargasDialog.interval': 'Intervalo',
    'shipments.adicionarCargasDialog.unit': 'Unidad',
    'shipments.adicionarCargasDialog.searchUnit': 'Buscar unidad…',
    'shipments.adicionarCargasDialog.minutes': 'minutos',
    'shipments.adicionarCargasDialog.hours': 'horas',
    'shipments.adicionarCargasDialog.preview': 'Vista previa',
    'shipments.adicionarCargasDialog.previewOne': '{{count}} fila',
    'shipments.adicionarCargasDialog.previewMany': '{{count}} filas',
    'shipments.adicionarCargasDialog.adding': 'Añadiendo…',
    'shipments.adicionarCargasDialog.addOneLine': 'Añadir fila',
    'shipments.adicionarCargasDialog.addLines': 'Añadir filas',
  },
}
